import type {ListOfferTemplatesSearchInput} from "@project/application/sales/offer-templates";
import type {Register, SearchSchemaInput} from "@tanstack/react-router";
import {listOfferTemplatesSearchSchema} from "@project/application/sales/offer-templates";
import {createFileRoute, redirect} from "@tanstack/react-router";

const validateTemplateRedirect = (search: ListOfferTemplatesSearchInput & SearchSchemaInput) =>
  listOfferTemplatesSearchSchema.parse(search);
export const Route = createFileRoute("/_app/sales/offer-templates/")<
  Register,
  typeof validateTemplateRedirect
>({
  beforeLoad: ({search}) => {
    throw redirect({replace: true, search, to: "/sales/offers/templates"});
  },
  validateSearch: validateTemplateRedirect,
});
